import { render, staticRenderFns } from "./InvoicePartyForm.vue?vue&type=template&id=dcb8ffd4&scoped=true&"
import script from "./InvoicePartyForm.vue?vue&type=script&lang=ts&"
export * from "./InvoicePartyForm.vue?vue&type=script&lang=ts&"
import style0 from "./InvoicePartyForm.vue?vue&type=style&index=0&id=dcb8ffd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb8ffd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VCol,VIcon,VRow,VTextField})
